import Monogram from "./Monogram";
import { NAV_LINKS } from "../data";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-night border-t border-parchment/10 py-10">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-6">
      <div className="flex items-center gap-3">
        <Monogram className="w-8 h-8" />
        <div>
          <p className="font-serif italic text-parchment">Irene Chen</p>
          <p className="text-xs font-mono text-parchment/50 tracking-wider">
            MSc Psychology · University of Exeter
          </p>
        </div>
      </div>
      <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2" aria-label="Footer">
        {NAV_LINKS.map((l) => (
          <a
            key={l.href}
            href={l.href}
            data-testid={`footer-link-${l.href.slice(1)}`}
            className="text-sm text-parchment/60 hover:text-parchment transition-colors duration-200"
          >
            {l.label}
          </a>
        ))}
      </nav>
      <p className="text-xs font-mono text-parchment/40">
        © {new Date().getFullYear()} Irene Chen
      </p>
    </div>
  </footer>
);

export default Footer;
